import.meta.env.DEV && import("@styles/main.sass");

import "./home.ts"
import startAlpine from "./alpine"

/**
 * Náhrada serverového `wp_is_mobile()`. Styly na `is-mobile` vypínají kompenzaci
 * šířky desktopového scrollbaru; dotykové zařízení ho překrývá, takže rozhoduje
 * hrubý ukazatel, ne User-Agent. Zároveň tím z HTML mizí poslední rozdíl mezi
 * návštěvníky a stránka jde uložit do sdílené cache – viz CACHING.md.
 */
if (window.matchMedia('(pointer: coarse)').matches) {
    document.body.classList.add('is-mobile')
}

/**
 * Alpine only starts once the dynamic import in `startAlpine()` resolves, so this
 * listener is always registered early enough for `x-data="header"` to bind.
 */
document.addEventListener('alpine:init', () => {
    window.Alpine.data('header', () => ({
        opened: false,
        closeOnMainClick: null as (() => void) | null,

        syncOpenState(): void {
            document.body.classList.toggle('u-hiddenOverflow', this.opened)

            const main = document.querySelector('main')
            if (!main) return

            // Hold one handler reference: the previous implementation handed
            // removeEventListener a fresh closure, so listeners piled up on every open.
            this.closeOnMainClick ??= () => { this.opened = false }

            if (this.opened) {
                main.addEventListener('click', this.closeOnMainClick)
            } else {
                main.removeEventListener('click', this.closeOnMainClick)
            }
        },
    }))

    /**
     * Rozbalení megamenu u položek první úrovně. Uplatní se jen na desktopu —
     * na mobilu je panel vypsaný napevno a `open` se nikam nepromítá.
     */
    window.Alpine.data('navigationItem', () => ({
        open: false,
        closeTimer: 0,

        // Musí odpovídat hranici `md` v resources/styles/sections/_navigation.sass
        desktop: window.matchMedia('(min-width: 64.01rem)'),

        // Na mobilu je podmenu vypsané napevno, hlásí se tedy vždy jako rozbalené
        get expanded(): boolean {
            return this.desktop.matches ? this.open : true
        },

        show(): void {
            window.clearTimeout(this.closeTimer)
            if (this.desktop.matches) this.open = true
        },

        hide(): void {
            window.clearTimeout(this.closeTimer)
            this.closeTimer = window.setTimeout(() => { this.open = false }, 150)
        },

        close(): void {
            window.clearTimeout(this.closeTimer)
            this.open = false
        },

        // focusout probublává i při přeskakování mezi odkazy uvnitř panelu
        hideOnLeave(event: FocusEvent): void {
            const item = event.currentTarget as HTMLElement | null

            if (!item?.contains(event.relatedTarget as Node | null)) this.close()
        },
    }))
})

startAlpine()

const headerEl = document.querySelector<HTMLElement>('[data-header]')

// Hide header on scroll down, reveal on scroll up
if (headerEl) {
    let lastScrollY = window.scrollY
    const THRESHOLD = 10

    window.addEventListener('scroll', () => {
        const currentScrollY = window.scrollY
        const delta = currentScrollY - lastScrollY

        // At very top — always show header in its standard state
        if (currentScrollY <= 0) {
            headerEl.classList.remove('is-hidden')
            lastScrollY = 0
            return
        }

        lastScrollY = currentScrollY

        if (Math.abs(delta) < THRESHOLD) return

        if (delta > 0 && currentScrollY > headerEl.offsetHeight && !headerEl.classList.contains('is-opened')) {
            // Scrolling down — hide header
            headerEl.classList.add('is-hidden')
        } else {
            // Scrolling up — reveal header
            headerEl.classList.remove('is-hidden')
        }
    }, { passive: true })
}

function openPdfModal(imageUrl: string) {
    const modal = document.getElementById('pdfModal') as HTMLDialogElement
    const image = document.getElementById('pdfModalImage') as HTMLImageElement
    if (!modal || !image) return

    image.src = imageUrl
    modal.showModal()
}

function closeDialog(modal: HTMLDialogElement | null) {
    if (modal?.open) modal.close()
}

document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement

    const closer = target.closest('.ModalCloser')
    if (closer) {
        closeDialog(closer.closest('dialog') as HTMLDialogElement | null)
        return
    }

    const previewLink = target.closest('[data-preview-image]') as HTMLElement | null
    if (previewLink) {
        e.preventDefault()
        const imageUrl = previewLink.getAttribute('href') || ''
        if (imageUrl) openPdfModal(imageUrl)
        return
    }

    const modalTrigger = target.closest('[data-advertisement-modal-trigger]') as HTMLElement | null
    if (modalTrigger) {
        const modalId = modalTrigger.getAttribute('data-advertisement-modal-trigger')
        const modal = modalId ? document.getElementById(modalId) as HTMLDialogElement | null : null
        modal?.showModal()
        return
    }

    document.querySelectorAll<HTMLDialogElement>('dialog[open]').forEach((modal) => {
        if (e.target === modal) closeDialog(modal)
    })
});

(() => {
    const FILE_EXTENSIONS = /\.(pdf|htm|docx?|xlsx?|pptx?|zip|rar|csv|txt|rtf)$/i

    document.querySelectorAll<HTMLAnchorElement>('a[href]').forEach((link) => {
        const isExternal = link.hostname && link.hostname !== window.location.hostname
        const isFile = FILE_EXTENSIONS.test(link.pathname)

        if (isExternal || isFile) {
            link.target = '_blank'
            link.rel = 'noopener noreferrer'
        }
    })
})();
